"use client"
/* */
import { callFunctionsInOrder } from '../../../lib/promises/callFunctionsInOrder.mjs';
import { callAndReact } from '../../../lib/promises/callAndReact.mjs';
import { getExecutionFunction } from './getExecutionFunction.mjs';

class ActionExecutionBatch {
  actions = [];
  baseAction;
  constructor(baseAction) {
    this.baseAction = baseAction;
  }
  addAction(action) {
    this.actions.push(action);
  }
  async executeBatch(args) {
    if (this.actions.length === 0) {
      return;
    }
    const batchFeedback = this.actions[this.actions.length - 1]?.actionProps.showFeedback;
    const executionState = this.baseAction.state.withFeedback(
      this.baseAction.needsConfirmation ? false : batchFeedback
    );
    const executionFunctions = this.actions.map((c) => getExecutionFunction(c));
    const executeBatch = callFunctionsInOrder(executionFunctions);
    let caughtError;
    await callAndReact(() => executeBatch(...args), {
      onAsync: () => executionState.onAsyncStart(),
      then: () => executionState.onSucceeded(),
      catch: (error) => {
        executionState.onFailed(error);
        caughtError = error;
      }
    });
    if (caughtError) {
      throw caughtError;
    }
  }
}

export { ActionExecutionBatch };
//# sourceMappingURL=ActionExecutionBatch.mjs.map
